'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _PropertyNote = require('../PropertyNote/PropertyNote');var _PropertyNote2 = _interopRequireDefault(_PropertyNote);
var _Contacts = require('../Contacts/Contacts');var _Contacts2 = _interopRequireDefault(_Contacts);
var _StickySection = require('./StickySection.scss');var styles = _interopRequireWildcard(_StickySection);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var StickySection = function StickySection(properties) {return (
    _react2.default.createElement('div', { className: styles.stickyWrapper },
      _react2.default.createElement('div', { id: 'stickySection' },
        _react2.default.createElement(_Contacts2.default, {
          locale: properties.locale,
          translate: properties.translate,
          contacts: properties.contacts,
          data: properties.data,
          realEstateData: properties.realEstateData,
          isPreview: properties.isPreview,
          showPrintPage: properties.showPrintPage,
          printPageShown: properties.printPageShown,
          isForeign: properties.isForeign,
          scrollToForm: properties.scrollToForm,
          incrementClicks: properties.incrementClicks }),

        !properties.isPreview ?

        _react2.default.createElement(_PropertyNote2.default, {
          placeholder: '' + properties.translate('propertyDetails', 'notesPlaceholder'),
          addNote: properties.addPropertyNote,
          value: properties.propertyNote }) :

        null)));};exports.default =





StickySection;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/StickySection/StickySection.js
// module id = 2828
// module chunks = 0